
export default {
    name: 'Theme3DesktopWithdrawalSteppersThirdStep',
    props: {
        isSuccess: {
            type: Boolean,
            default: true,
        },
        amount: {
            type: [String, Number],
            default: '',
        },
        currency: {
            type: String,
            default: '',
        },
    },
    computed: {
        depositDetail() {
            return this.$store.state.sockets.displayGetBonusDetail
        },
        player() {
            return this.$store.state.player.player
        },
    },
    methods: {
        onClickConfirm() {
            this.$emit('click')
        },
    },
}
